import {ValoriGruppo} from "@commons/mapping/ValoriGruppo";

export type TipoGiustificativo = "ORARIO" | "IMPORTO" | "QUANTITA" | "EVENTO";
export type TipoGiu = "O" | "I" | "Q" | "E";

export interface Giustificativi {
    codGiu: string | null,
    tipoGiu: TipoGiu | null,
    descrizione: string | null, // MAX 40 CHAR
    tipoOreGiu: "M" | "E" | "N" | "S" | "T" | "G" | "X" | "Z" | "O" | null,
    stampaSuGiornale: boolean,
    stampaSuAllegato: boolean,
    tipoGiuMassa: 0 | 1 | 2,
    lungaAssenza?: number, // NON UTILIZZATO!!!
    tipoAutomatismo: 0 | 1 | 2 | 3 | 5 | 6 | 7 | null,
    gruppoValori?: ValoriGruppo[],
    codGiuLinked: string | null,
    bgColor: string | null,
    conta: number,
    usaInPianificazione: boolean,
}

export class Giustificativi {
    static getTipoGiustificativo = (giustificativo: Giustificativi): TipoGiustificativo => {
        switch (giustificativo.tipoGiu) {
            case "O":
                return "ORARIO";
            case "I":
                return "IMPORTO";
            case "Q":
                return "QUANTITA";
            case "E":
                return "EVENTO";
            default:
                throw new Error("Tipo non valido: " + giustificativo.tipoGiu);
        }
    };

    /*
    A function that defines the sort order.
    The return value should be a number whose sign indicates the relative order of the two elements:
    negative if a is less than b, positive if a is greater than b, and zero if they are equal.
    NaN is treated as 0. The function is called with the following arguments:
      a  The first element for comparison. Will never be undefined.
      b  The second element for comparison. Will never be undefined.*/
    static compareFn = (a: Giustificativi, b: Giustificativi): number => {
        if (a) {
            if (b) {
                return a.descrizione!.localeCompare(b.descrizione!);
            } else return 1;
        } else if (b) {
            return -1;
        } else return 0;
    }
}